'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/~/inline-style-prefix-all/lib/utils/isPrefixedValue.js
 ** module id = 621
 ** module chunks = 0 2
 **/